import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { X, Users, Clock, TrendingUp } from 'lucide-react';

interface RecruitmentContent {
  title?: string;
  subtitle?: string;
  description?: string;
  link_url?: string;
  image_url?: string;
}

interface RecruitmentPopupProps {
  onClose: () => void;
  onNavigate?: (page: string) => void;
  content?: RecruitmentContent;
}

// Enhanced but lightweight recruitment popup with engaging content
export const RecruitmentPopup = React.memo(function RecruitmentPopup({ onClose, onNavigate, content }: RecruitmentPopupProps) {
  const handleAdvertiseClick = () => {
    const link = content?.link_url || '/employer/dashboard';
    if (onNavigate) {
      onNavigate('employer/dashboard');
    } else {
      window.location.href = link;
    }
    onClose();
  };

  const handleLearnMoreClick = () => {
    const link = content?.link_url || '/employers';
    if (onNavigate) {
      onNavigate('employers');
    } else {
      window.location.href = link;
    }
    onClose();
  };

  const title = content?.title || 'Looking to Hire?';

  return (
    <div className="fixed top-24 right-6 z-[60] w-72 animate-in slide-in-from-right-2 duration-300">
      <Card className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <CardContent className="p-4">
          <div className="flex items-start justify-between mb-2">
            <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="p-1 h-6 w-6 rounded-full"
            >
              <X className="w-3.5 h-3.5" />
            </Button>
          </div>
          <p className="text-xs text-gray-700 mb-3">Post your job and reach qualified candidates fast.</p>
          <div className="space-y-2 mb-3">
            <div className="flex items-center gap-2 text-xs text-gray-700">
              <Users className="w-3.5 h-3.5 text-blue-600" />
              <span>50K+ candidates ready to apply</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-700">
              <Clock className="w-3.5 h-3.5 text-green-600" />
              <span>Applications within 24 hours</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-700">
              <TrendingUp className="w-3.5 h-3.5 text-purple-600" />
              <span>High visibility across Nepal</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Button 
              size="sm"
              className="h-8 text-xs bg-blue-600 hover:bg-blue-700"
              onClick={handleAdvertiseClick}
            >
              Advertise Now
            </Button>
            <Button 
              variant="outline"
              size="sm"
              className="h-8 text-xs border-gray-300 hover:bg-gray-50"
              onClick={handleLearnMoreClick}
            >
              Learn More
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
});
